import {DatePipe}                           from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {MoodRecordLogIntf}                  from '@djsharkk/logr-types';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-mood',
			   imports: [
				   DatePipe
			   ],
			   templateUrl: './table-row-mood.component.html',
			   styleUrl   : './table-row-mood.component.css'
		   })
export class TableRowMoodComponent extends TableRowBase<MoodRecordLogIntf> {
	row = input.required<TableRow>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
}
